import { useQuery } from '@tanstack/react-query';
import { cashTransactionsApi } from '../api/cash-transactions.api';
import { TransactionType, TransactionStatus } from '../types/cash-transaction.types';

export interface TransactionFilters {
  page?: number;
  limit?: number;
  type?: TransactionType;
  status?: TransactionStatus | string;
  startDate?: string;
  endDate?: string;
  search?: string;
}

export const useCashTransactions = (filters?: TransactionFilters) => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['cash-transactions', filters],
    queryFn: () => cashTransactionsApi.getAll(filters),
  });

  return {
    transactions: data?.data ?? [],
    meta: data?.meta ?? { total: 0, page: 1, limit: 20, totalPages: 1, hasMore: false },
    summary: data?.summary ?? null,
    isLoading,
    error,
    refetch,
  };
};
